
import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");


  const getId = (id) => {
    if (id) {
      return <PropertyId>#{id}</PropertyId>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };
  const getStatus = (status) => {
    if (status == 1) {
      return <Unverified>Unverified</Unverified>;
    } else if (status == 2) {
      return <Verified>Verified</Verified>;
    } else if (status == 3) {
      return <Active>Active</Active>;
    } else if (status == 4) {
      return <Enrolled>Enrolled</Enrolled>;
    } else if (status == 5) {
      return <Default>Defaulter</Default>;
    } else {
      return <Default>N/A</Default>;
    }
  };
  
  const getCurrentAppVersion = (currentAppVersion) => {
  if (currentAppVersion) {
    return (
      <CurrentAppVersion>
        {currentAppVersion}
      </CurrentAppVersion>
    );
  }

  return <Na>N/A</Na>;
};



  const getHoldOutBalance = (holdOutBalance) => {
    if (holdOutBalance > 0) {
      return <p>₹ {holdOutBalance}</p>;
    } else {
      return <p>₹ 0</p>;
    }
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>
            {getId(selectedData?.id) || "N/A"}
            </Status>
            <Status className="ml-3">
            {getStatus(selectedData?.status) || "N/A"}
          </Status>
          <Status className="ml-3">
            {getCurrentAppVersion(selectedData?.currentAppVersion) || "N/A"}
          </Status>
        </div>
            <Column>
          <FirstColumn>
          <SubHeading>Owner Name</SubHeading>
          <Paragraph>{selectedData?.name || "N/A"}</Paragraph>
          </FirstColumn>
           <SecondColumn>
            <SubHeading>City</SubHeading>
            <Paragraph>{selectedData?.city || "N/A"}</Paragraph>
          </SecondColumn> 
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("LL") || "N/A"}
            </Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Updated At</SubHeading>
            <Paragraph>
              {moment(selectedData?.updatedAt).format("LL") || "N/A"}
            </Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>
      
          <TemplateButton
            ml
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
            Hold Amount
          </TemplateButton>
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
              <SingleItem
                name={"Phone Number"}
                value={selectedData?.mobile || "N/A"}
              />
              <SingleItem
                name={"Property Count"}
                value={selectedData?.propCount || "N/A"}
              />
              <SingleItem
                name={"Acquired By"}
                value={selectedData?.acquiredBy|| "N/A"}
              />
              <SingleItem
                name={"Card Charges"}
                value={selectedData?.creditCardCharges|| "N/A"}
              />
              <SingleItem
                name={"Remark"}
                value={selectedData?.remarks|| "N/A"}
              />
            </>
          )}


          {detailType === "2" && (
            <>
              <SingleItem 
              name="Pending Amount" value={getHoldOutBalance(selectedData?.holdOutBalance || "N/A")} 
              />
              <SingleItem
                name="Holded Amount"
                value={selectedData?.security || "N/A"}
              />
            </>
          )}
        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <span>:</span>
    <Value>
      {(name === "Security" || name === "Fine" || name === "Maintenance Fee") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      {(name === "Agreement Period" ||
        name === "Notice Period" ||
        name === "Lock-In Period") && <span className="ml-1">months</span>}
      {name === "Grace Period" && <span className="ml-1">days</span>}
    </Value>
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest}
    >
      {rest.children}
    </button>
  );
};
const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 `;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Name = tw.span`text-sm text-gray-500  w-32`;
const Value = tw.span`text-sm text-black font-medium w-80 px-6 `;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Verified = tw.div`bg-teal-100 text-teal-700 text-xs border-teal-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Enrolled = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Default = tw.div`
  bg-red-100
  text-red-700
  text-xs
  border-red-300
  border
  w-24
  h-7
  flex
  items-center
  justify-center
  rounded-full
`;
const CurrentAppVersion = tw.div`bg-gray-500 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`
const Na = tw.div`bg-gray-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`
export default ViewDetailModel;
